/**
 * @description Авторизация, Rambler ID, Сбер ID
 */

import React, { memo } from 'react'
import { useEffectOnce } from '@shared/lib/hooks/useEffectOnce'

import { initAuthAC, loginAC } from '@app/model/actions'
import { useAppDispatch } from '@app/model/store'
import Authorization from '@app/service/authorization'

import { addSberIDScript } from '@shared/lib/helpers/externalScripts/sberIdScript'

const IS_PROD = process.env.GITLAB_STATUS === '0'

const LINK_AUTH_EVENTS = 'https://id.rambler.ru/rambler-id-helper/auth_events.js'

import getSberIdFlag from '@shared/lib/helpers/featureFlag'

/**
 * @constant scriptData
 * @description описывает функцию для создания скрипта, и события onload
 */
const scriptData = `
  (function (_window, _document, _script, _src) {
    var n = _document.getElementsByTagName(_script)[0];
    var s = _document.createElement(_script);
    s.type = "text/javascript";
    s.async = true;
    s.src = _src;
    s.onload = function () {
      if (typeof _window.onRamblerIdLoad === 'function') {
        _window.onRamblerIdLoad();
      }
    };
    n.parentNode.insertBefore(s, n);
  })(window, document, "script", "${LINK_AUTH_EVENTS}");
`

const AuthEventsScript = () => {
  const dispatch = useAppDispatch()

  useEffectOnce(() => {
    const isSberID = !getSberIdFlag()
    console.dev('sberid: 1.isSberID Mode', isSberID)

    const addRamblerScript = () => {
      return new Promise((resolve) => {
        // глобальный коллбэк, который позволяет узнать о загрузке
        window.onRamblerIdLoad = () => {
          console.dev('Auth script loaded from onRamblerIdLoad callback')
          resolve()
        }

        const scriptTag = document.createElement('script')
        scriptTag.type = 'text/javascript'
        scriptTag.text = scriptData

        // создаёт <script src="auth_events.js"> и вешает на него onload
        document.body.appendChild(scriptTag)
      })
    }

    // ***** запуск *****
    setTimeout(() => {
      if (!isSberID) {
        addRamblerScript().then(() => {
          if (!Authorization.isInit()) {
            dispatch(initAuthAC())
            console.dev('Init "RamblerID" script success!')
          }
        })
      } else {
        // recheck
        // dispatch(loginAC())
        // console.dev('sberid: 2. recheck loginAC')

        // authentication
        addSberIDScript().then(() => {
          const isInitiated = console.dev('sberid: 2. initAuthAC isInit', Authorization.isInit())
          if (!Authorization.isInit()) {
            console.dev('sberid: 3. initAuthAC started')
            dispatch(initAuthAC())
          }
        })
      }
    }, 1)
  }, [])

  return <span className='visually-hidden' />
}

export default memo(AuthEventsScript)
